"use client";

import { useSpineSlice } from "@/components/site/motion/useSpineSlice";
import { ProductTrustedLogos } from "@/components/sections/products/ProductTrustedLogos";
import { SideTickList } from "@/components/site/SideTickList";
import { SplitTarget } from "@/components/site/SplitTarget";
import { useContent } from "@/components/site/ContentProvider";

/**
 * Product videos stay `data-src` until spine `preloadProductVideos` /
 * `playProductVideos` (Services+ ownership). SiteMotion is the sole load owner.
 */
export function Products() {
  useSpineSlice((m) => m.spine!.buildProducts());
  const site = useContent();

  return (
    <div className="landing_content products_content f a-c j-c" id="products">
      <div className="products_wrap full_page">
        {site.products.map((product) => (
          <div className="product_container full_bg" id={product.id} key={product.id}>
            <div className="product_video fc_video full_bg f a-c j-c">
              <video
                muted
                playsInline
                {...{ "webkit-playsinline": "" }}
                loop
                preload="none"
                data-src={product.video}
              />
            </div>
            <div className="product_inner f f-c a-c j-c">
              <div className="product_set f f-c product_aspect">
                <div className="product_head f f-c a-c j-c">
                  <h2 className="mobile">{product.name}</h2>
                  <h2 className="desktop">{product.name}</h2>
                  <span className="uppercase spacing">{product.tagline}</span>
                </div>
                <div className="mobile">
                  <div className="product_info f f-c">
                    <SplitTarget as="span" className="uppercase _split" text={product.description} />
                    <SideTickList title={product.modulesLabel} items={product.modules} />
                    <SideTickList
                      title={product.integrationsLabel}
                      items={product.integrations}
                    />
                  </div>
                </div>
                <ProductTrustedLogos />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
